// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__RF_bh","rootNoMargin":"styles_rootNoMargin__14hsc"};